import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../Environment/environment';

@Injectable({
  providedIn: 'root',
})
export class MapService {
  constructor(private http: HttpClient) {}

  // ---------------------- Get Map API ---------------------- //

  getAllFence(api: string) {
    return this.http.get(environment.baseUrl + api);
  }

  // ---------------------- Get Dumpyard Location By CityId API ---------------------- //

  getDumpyardLocation(api: string) {
    const url = `${environment.baseUrl}${api}`;
    return this.http.get(url);
  }

  // ---------------------- Get Dumpyard Location By CityId API ---------------------- //

  getDumpsterLocation(api: string, dumpsterId: any) {
    const url = `${environment.baseUrl}${api}?Userid=${dumpsterId}`;
    return this.http.get(url);
  }
}
